import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'
import { IS_ACCEPTANCE, IS_PRODUCTION } from '../../config'
import { Button } from '@mui/material'
import { Events } from '../../FSM/shared/constants'
import { FSMService } from '../../FSM'

const useStyles = makeStyles()((theme: Theme) => ({
  btnStandards: {
    position: 'absolute',
    top: '20px',
    left: '200px',
    color: theme.palette.secondary.contrastText,
  },
}))

// Navigates to UI standards page on LOCAL and DEV environments
const StandardsButton = () => {
  const { classes } = useStyles()

  return !IS_PRODUCTION && !IS_ACCEPTANCE ? (
    <Button
      className={classes.btnStandards}
      onClick={() => FSMService.flowService.send({ type: Events.STANDARDS })}
    >
      UI Standards
    </Button>
  ) : null
}

export default StandardsButton
